import { useMutation } from "@apollo/client";
import { SYNC_MAILBOX } from "../mailbox.queries";
import { SyncMailboxMutation } from "../../../__generated__/SyncMailboxMutation";

export const useSyncMailbox = () => {
  return useMutation<SyncMailboxMutation>(SYNC_MAILBOX, {
    refetchQueries: "active",
  });
};
